import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hbs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      localStorage.removeItem("hbs_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(e);
  }
);

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_bonsevis-platform/artifacts/vkk6s6n9_Hayti%20Bon%20S%C3%A8vis%20Shipping.png",
  crest: "https://customer-assets.emergentagent.com/job_bonsevis-platform/artifacts/vkk6s6n9_Hayti%20Bon%20S%C3%A8vis%20Shipping.png",
  flag: "https://customer-assets.emergentagent.com/job_bonsevis-platform/artifacts/yybaez53_photo_8.jpg",
};

export const BRAND = {
  short: "HBS",
  name: "Hayti Bon Sèvis Shipping",
  name_line1: "HAYTI",
  name_line2: "BON SÈVIS SHIPPING",
  tagline: "Seli l ye",
  motto: "Seli l ye",
  domain: "bonsevis.com",
  phone: "+1-305-999-1292",
  phone_e164: "13059991292",
};

export const buildWhatsAppLink = (message) => {
  const txt = message || "Hello Hayti Bon Sèvis Shipping, I would like to inquire about a shipment.";
  return `https://wa.me/${BRAND.phone_e164}?text=${encodeURIComponent(txt)}`;
};
